import EquityInASinglePrivatelyHeldCompanyForm from "./EquityInASinglePrivatelyHeldCompanyForm";

export default EquityInASinglePrivatelyHeldCompanyForm;
